<template>
	<div class="relative">
		<div class="flex flex-wrap items-center justify-between">
			<div class="loader my-5 flex flex-1 flex-col items-start justify-between gap-x-6 gap-y-3 sm:flex-nowrap">
				<div class="w-full space-y-5">
					<a-skeleton-button class="h-16 w-full max-w-[200px]" block active loading />
				</div>
				<a-skeleton-button class="h-10" active loading />
			</div>
			<a-skeleton-button class="h-[56px] !rounded-md" active loading />
		</div>

		<div class="my-16">
			<div class="flex flex-wrap items-center justify-between gap-x-6 gap-y-3">
				<a-skeleton-button class="!relative !block h-[174px] !max-w-[752px] !rounded-md" block active />
				<a-skeleton-button class="!relative !block h-[174px] !max-w-[284px] !rounded-md" block active />
			</div>
		</div>

		<a-skeleton-button class="!relative !block h-[400px] w-full !rounded-md" block active />
	</div>
</template>
